

  export const Rutas = 'https://apiescuela.cieep.com/';
   export const RutasImg = 'https://apiescuela.cieep.com/';
  // export const Rutas = 'http://192.168.1.236:8888/apiescuela2020/web/';
  // export const Rutas = 'http://127.0.0.1:8000/';
    // export const RutasImg = 'http://127.0.0.1:8000/';
  // export const RutasImg = 'http://192.168.1.236:8888/apiescuela2020/web/';

